import { __decorate, __metadata, __param } from "tslib";
import { Symbols } from '@/symbols';
import { inject, injectable } from 'inversify';
import { map, flatMap, join } from 'lodash';
import { formatDate } from '@/@core/utils/dateFormat';
import { E_ChargeMode, E_PackageTag } from '@/apis/service/PackageApi.types';
import { AllPackageOptionsListData, HistoryPackageOptionsListObj, PackageOptionsListObj } from './CompanyBase/AddOrPrivilegeService.type';
import { canUseInSeatsPrivilege } from '@/utils/packageBusinessMode';
let CompanyEditPrivilegeService = class CompanyEditPrivilegeService {
    constructor(packageApi, companyApi) {
        this.packageApi = packageApi;
        this.companyApi = companyApi;
        /**
         * 当前所有的options  包括历史
         * 在筛选时，历史需要将现在套餐所包含的数据去重
         */
        this.currentPackages = [];
        /**
         * 是否为匿名套餐，如果是匿名套餐则不显示企业版、账号数
         * 匿名套餐、更新所有被分配的用户权限
         */
        this.currentSelect = [];
    }
    /* 初始化表格中的值 */
    initEditorFormData(item) {
        /* 基础信息 */
        const company_privilege_contract_pojo = {
            charge_mode: item.charge_mode,
            id: item.id,
            begin_at_value: formatDate({ date: item.begin_at }),
            end_at_value: formatDate({ date: item.end_at }),
            seat: item.seat,
            export_total_daily: item.export_total_daily
                ? item.export_total_daily
                : 0,
            contract_number: item.contract_number,
            limitation_ways: item.limitation_ways || [],
            concurrency: item.concurrency || 1,
            business_package_enabled: item.business_package_enabled,
        };
        // 所有选择的套餐数组id
        this.currentSelect = map(item.packages, p => p.id);
        return company_privilege_contract_pojo;
    }
    /**
     * 在新增权限也用到了，谨慎修改
     * */
    async allDataManager(modeType) {
        const allData = new AllPackageOptionsListData();
        const type = modeType;
        await Promise.all([
            this.packagesDataManager(type),
            this.historyPackagesDataManager()
        ]).then(resolve => {
            allData.allCurrentOptionsData = resolve[0];
            allData.allHistoryOptionsData = resolve[1];
            allData.charge_mode = type;
        });
        return allData;
    }
    /**
     * 当前套餐处理  这里在新增权限/编辑权限的时候也会用到，所有用传值及返回的方式去写
     */
    async packagesDataManager(type) {
        const getAllData = (await this.packageApi.getPackageByChargeMode(type)).filter(canUseInSeatsPrivilege);
        this.currentPackages = getAllData;
        const allCurrentData = new PackageOptionsListObj();
        getAllData.forEach((item) => {
            switch (item.package_tag) {
                case E_PackageTag.SUB_INDEPENDENT:
                    allCurrentData.subindependentOptions.push(item);
                    break;
                case E_PackageTag.BASE:
                    allCurrentData.independentOptions.push(item);
                    break;
                case E_PackageTag.ADDON:
                    allCurrentData.addonOptions.push(item);
                    break;
                case E_PackageTag.ANONYMOUS:
                    allCurrentData.anonymousOptions.push(item);
                    break;
                case E_PackageTag.OPEN_API:
                    allCurrentData.openApiOptions.push(item);
                    break;
                default:
            }
        });
        return allCurrentData;
    }
    /**
     * 历史套餐数据处理 获取一次 这里在新增权限/编辑权限的时候也会用到 这里根据是否显示历史信息决定是否显示
     * @returns
     */
    async historyPackagesDataManager() {
        const getAllHistoryData = (await this.packageApi.getPackageByChargeMode(E_ChargeMode.HISTORICAL)).filter(canUseInSeatsPrivilege);
        const allHistoryData = new HistoryPackageOptionsListObj();
        getAllHistoryData.forEach((item) => {
            switch (item.package_tag) {
                case E_PackageTag.SUB_INDEPENDENT:
                    allHistoryData.historySubindependentOptions.push(item);
                    break;
                case E_PackageTag.BASE:
                    allHistoryData.historyIndependentOptions.push(item);
                    break;
                case E_PackageTag.ADDON:
                    allHistoryData.historyAddonOptions.push(item);
                    break;
                default:
            }
        });
        return allHistoryData;
    }
    /**
     * 提交数据的处理(新增编辑公用)
     * @param allSelectData
     * @returns
     */
    privilegeList(allSelectData) {
        return allSelectData.currentSelectPackages.map(item => {
            const obj = {
                package_id: item,
            };
            return obj;
        });
    }
    /**
     * 提交验证：新增编辑均有，如果没有匿名套餐，不能提交
     * 返回时注意，返回的是所有数据，匿名和非匿名需要分开处理。
     */
    packageValidation(allSelectData) {
        return allSelectData.currentSelectPackages.length === 0;
    }
    updateCompanyInfoList(id) {
        return this.companyApi.getCompanyInfo(id).then(companyInfo => {
            const { ip_range, ipv6, domains, } = companyInfo;
            return {
                ip_range,
                ipv6,
                domains: join(domains, ','),
            };
        });
    }
    /**
     * 提交表单编辑数据的接口
     * @param params
     * @returns
     */
    putUpdateCompanyPrivilege(params) {
        return this.packageApi.putUpdateCompanyPrivilege(params);
    }
    getSafeChargeModes(filterFn) {
        return this.packageApi.getChargeModes().then(chageModeCodes => {
            return flatMap(chageModeCodes, chageModeCode => {
                const chageMode = chageModeCode.system_code;
                if (filterFn(chageMode) && chageMode !== E_ChargeMode.HISTORICAL) {
                    return [chageMode];
                }
                else {
                    return [];
                }
            });
        });
    }
};
CompanyEditPrivilegeService = __decorate([
    injectable(),
    __param(0, inject(Symbols.PackageApi)),
    __param(1, inject(Symbols.CompanyApi)),
    __metadata("design:paramtypes", [Object, Object])
], CompanyEditPrivilegeService);
export { CompanyEditPrivilegeService };
